import { AfterViewInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { CloseChat } from '../store/chat.actions';
import { getUrlChat, selectChatOpened } from '../store/chat.selectors';

import { getPage } from '@core/infrastructure/state/core.selectors';
import { StaticResourceService } from '@core/services/static-resource.service';
import { TimestampService } from '@core/services/timestamp.service';

@Component({
    selector: 'url-chat',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./url-chat.component.scss'],
    templateUrl: './url-chat.component.html',
})

export class UrlChatComponent implements OnInit, AfterViewInit {
    private readonly _loading$: BehaviorSubject<boolean> = new BehaviorSubject(true);

    public loading$: Observable<boolean> = this._loading$.asObservable();

    public urlChat$: Observable<SafeResourceUrl>;

    public selectChatOpened$: Observable<boolean>;

    public isPage$ = this.store.select(getPage).pipe(map((page: any) => page === 'ItxChatPage'));

    constructor(
        private readonly store: Store,
        private readonly sanitizer: DomSanitizer,
        private readonly timestampSvc: TimestampService,
        private readonly staticResourceService: StaticResourceService,
    ) {}

    public ngOnInit(): void {
        const timestamp = this.timestampSvc.getTs();
        const styleFileName = `chatbot.css?t=${timestamp}`;
        const head = document.getElementsByTagName('head')[0];
        const link = document.createElement('link');
        this.selectChatOpened$ = this.store.select(selectChatOpened);
        this.urlChat$ = this.store.select(getUrlChat).pipe(
            map((urlChatInfo) => this.sanitizer.bypassSecurityTrustResourceUrl(urlChatInfo.configuration.url)),
            shareReplay(1)
        );

        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.as = 'style';
        link.href = this.staticResourceService.getStatic() + 'itxwebstandard/css/' + styleFileName;
        head.appendChild(link);
    }

    public ngAfterViewInit(): void {
        const iframeElement = document.getElementById('imbee-app-iframe');
        if (iframeElement) {
            iframeElement.addEventListener('load', () => {
                this._loading$.next(false);
            });
        }
    }

    public close(): void {
        this.store.dispatch(CloseChat());
    }
}
